export default __webpack_public_path__ + "static/15-b6027e8a749c4ef3c50a9789f049ffd5.jpg";